import { createFileRoute } from '@tanstack/react-router'

import { RakeRaceRoute } from '@/pages/promotion/route-entries/rake-race'

export const Route = createFileRoute('/_layout/promotion/august-2025/_tabs/rake-race')({
  component: RakeRaceRoute,
})
